import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { ErrorBoundary } from '@/components/error-boundary'
import { ScrollToTop } from '@/components/scroll-to-top'
import { AppProviders } from '@/providers/app-providers'
import { AnalyticsConsent } from '@/components/marketing/analytics-consent'

import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/600.css'
import '@fontsource/dm-sans/700.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'

import './styles/globals.css'

export default function App() {
  useEffect(() => {
    // Drop the SPA-shell marker the prerender script may have set, so the
    // hidden body becomes visible once React has mounted at the real route.
    document.documentElement.removeAttribute('data-spa-shell')
  }, [])

  return (
    <ErrorBoundary>
      <AppProviders>
        <ScrollToTop />
        <Outlet />
        <AnalyticsConsent />
      </AppProviders>
    </ErrorBoundary>
  )
}
